<app-confirmation-view
  [options]="options"
  [running]="running"
  (cancelled)="cancel()"
  (confirmed)="confirm()"
></app-confirmation-view>
